/* eslint-disable*/
import { ThunkMiddleware } from 'redux-thunk';
import { Middleware } from 'redux';

const middleware = (): Array<ThunkMiddleware | Middleware> => {
  return <any[]>[];
};

export default middleware;
